import getCookieMap from './getCookieMap';
import { KNOWN_COOKIES } from '../constants';

export default function harvestIdentifiers() {
  const cookies = getCookieMap(document.cookie);
  const matchedCookies = KNOWN_COOKIES.reduce((map, key) => {
    return cookies[key] ? { ...map, [key]: cookies[key] } : map;
  }, {});

  return {
    ...matchedCookies,
  };
}
